import { Trans } from '@lingui/macro';

export const LoadingText = () => (
  <Trans id="accessibility.loading">Loading...</Trans>
);
